<script>
  import Header from "./HeaderDay.svelte";
  import TimesheetCards from "./TimesheetCard.svelte";
  import Spinner from "../Spinner.svelte";
  import Icon from "svelte-awesome";
  import { angleDoubleDown, angleDoubleUp } from "svelte-awesome/icons";
  export let data;
  export let modaldate;
  export let staff;
  export let user;
  export let newdate;

  let timesheet = data.Result;
  let timesheetId = data.Result.TimesheetId;
  let monday = data.Result.Monday.TimeCards;
  let tuesday = data.Result.Tuesday.TimeCards;
  let wednesday = data.Result.Wednesday.TimeCards;
  let thursday = data.Result.Thursday.TimeCards;
  let friday = data.Result.Friday.TimeCards;
  let saturday = data.Result.Saturday.TimeCards;
  let sunday = data.Result.Sunday.TimeCards;
  // days total hours variable //
  let monday_totalhours = timesheet.Monday.DayTotalWork;
  let tuesday_totalhours = timesheet.Tuesday.DayTotalWork;
  let wednesday_totalhours = timesheet.Wednesday.DayTotalWork;
  let thursday_totalhours = timesheet.Thursday.DayTotalWork;
  let saturday_totalhours = timesheet.Saturday.DayTotalWork;
  let sunday_totalhours = timesheet.Sunday.DayTotalWork;
  let friday_totalhours = timesheet.Friday.DayTotalWork;

  // days total pto hours variable //
  let monday_total_pto_hours = timesheet.Monday.PTOHours;
  let tuesday_total_pto_hours = timesheet.Tuesday.PTOHours;
  let wednesday_total_pto_hours = timesheet.Wednesday.PTOHours;
  let thursday_total_pto_hours = timesheet.Thursday.PTOHours;
  let saturday_total_pto_hours = timesheet.Saturday.PTOHours;
  let sunday_total_pto_hours = timesheet.Sunday.PTOHours;
  let friday_total_pto_hours = timesheet.Friday.PTOHours;

  // days total pto hours variable //
  let monday_total_ot_hours = timesheet.Monday.OTHours;
  let tuesday_total_ot_hours = timesheet.Tuesday.OTHours;
  let wednesday_total_ot_hours = timesheet.Wednesday.OTHours;
  let thursday_total_ot_hours = timesheet.Thursday.OTHours;
  let saturday_total_ot_hours = timesheet.Saturday.OTHours;
  let sunday_total_ot_hours = timesheet.Sunday.OTHours;
  let friday_total_ot_hours = timesheet.Friday.OTHours;

  // days date variable//
  let monday_date = timesheet.Monday.Date;
  let tuesday_date = timesheet.Tuesday.Date;
  let wednesday_date = timesheet.Wednesday.Date;
  let thursday_date = timesheet.Thursday.Date;
  let friday_date = timesheet.Friday.Date;
  let saturday_date = timesheet.Saturday.Date;
  let sunday_date = timesheet.Sunday.Date;
  let collapse = localStorage.getItem("collapse");
  let showDetails = localStorage.getItem("collapse");
  jQuery(function() {
    document.getElementById("tabcollapse").click();
  });
  function toggleCollapse() {
    collapse = !collapse;
    localStorage.setItem("collapse", collapse);
    showDetails = collapse;
    if (collapse) {
      toggleShowDetails(showDetails);
    } else {
      localStorage.removeItem("opened-cards");
    }
    //document.getElementById("tabcollapse").click();
  }

  function toggleShowDetails(res) {
    var openedCards = [];
    setTimeout(function() {
      jQuery(".card-container .content").each(function(ind, val) {
        if (
          jQuery(val)
            .parent()
            .html()
            .indexOf("content") > -1
        ) {
          openedCards.push({
            id: jQuery(val)
              .parent()
              .find(".card-title")
              .data("activityid"),
            status: res
          });
        }
      });
      localStorage.setItem("opened-cards", JSON.stringify(openedCards));
    }, 100);
  }
</script>

<style>
  .timesheet-container {
    display: flex;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
    margin-bottom: 30px;
    overflow: auto;
  }
  .day-container {
    width: 100%;
    max-width: calc(100% / 7);
    margin: 0px 5px;
  }
  .empty-timesheet-message {
    text-align: center;
    padding: 10px;
    background-color: #dcdde1;
    border: 30px;
    margin-top: 15px;
  }
  @media (max-width: 768px) {
    .timesheet-container {
      display: none;
    }
  }
</style>

{#if timesheet === null}
  <Spinner />
{:else}
  <button on:click={toggleCollapse} id="tabcollapse" style="margin: 10px;">
    {#if collapse === true}
      Collapse All
      <Icon data={angleDoubleUp} />
    {:else}
      Expand All
      <Icon data={angleDoubleDown} />
    {/if}
  </button>
  <div class="timesheet-container">
    <div class="day-container">
      <Header
        day={'Monday'}
        hours={monday_totalhours}
        ptoHours={monday_total_pto_hours}
        otHours={monday_total_ot_hours}
        date={monday_date} />
      {#if monday.length !== 0}
        <div class="cards-container">
          {#each monday as timesheet}
            <TimesheetCards
              {showDetails}
              collapseAll={collapse}
              title={timesheet.TaskNotes}
              timesheetId={timesheetId}
              job={timesheet.New_JobName}
              deliverable={timesheet.New_DeliverableName}
              task={timesheet.New_Costcentrename}
              taskid={timesheet.New_CostcentreId}
              totalhours={timesheet.New_Actualworkhrs}
              id={timesheet.New_DeliverableId}
              day={'Monday'}
              weekstart={modaldate}
              jobid={timesheet.New_JobId}
              {newdate}
              completed={timesheet.New_IsCompleted}
              {staff}
              activityid={timesheet.ActivityId}
              actualstart={timesheet.ActualStart}
              status={data.Result.Status}
              {user} />
          {/each}
        </div>
      {:else}
        <div class="empty-timesheet-message">No data available</div>
      {/if}
    </div>
    <div class="day-container">
      <Header
        day={'Tuesday'}
        date={tuesday_date}
        hours={tuesday_totalhours}
        ptoHours={tuesday_total_pto_hours}
        otHours={tuesday_total_ot_hours} />
      {#if tuesday.length !== 0}
        <div class="cards-container">
          {#each tuesday as timesheet}
            <TimesheetCards
              {newdate}
              {showDetails}
              collapseAll={collapse}
              title={timesheet.TaskNotes}
              timesheetId={timesheetId}
              job={timesheet.New_JobName}
              deliverable={timesheet.New_DeliverableName}
              task={timesheet.New_Costcentrename}
              taskid={timesheet.New_CostcentreId}
              totalhours={timesheet.New_Actualworkhrs}
              id={timesheet.New_DeliverableId}
              day={'Tuesday'}
              weekstart={modaldate}
              jobid={timesheet.New_JobId}
              completed={timesheet.New_IsCompleted}
              {staff}
              activityid={timesheet.ActivityId}
              actualstart={timesheet.ActualStart}
              status={data.Result.Status}
              {user} />
          {/each}
        </div>
      {:else}
        <div class="empty-timesheet-message">No data available</div>
      {/if}
    </div>
    <div class="day-container">
      <Header
        day={'Wednesday'}
        date={wednesday_date}
        hours={wednesday_totalhours}
        ptoHours={wednesday_total_pto_hours}
        otHours={wednesday_total_ot_hours} />
      {#if wednesday.length !== 0}
        <div class="cards-container">
          {#each wednesday as timesheet}
            <TimesheetCards
              {newdate}
              {showDetails}
              collapseAll={collapse}
              title={timesheet.TaskNotes}
              timesheetId={timesheetId}
              job={timesheet.New_JobName}
              deliverable={timesheet.New_DeliverableName}
              task={timesheet.New_Costcentrename}
              taskid={timesheet.New_CostcentreId}
              totalhours={timesheet.New_Actualworkhrs}
              id={timesheet.New_DeliverableId}
              day={'Wednesday'}
              weekstart={modaldate}
              jobid={timesheet.New_JobId}
              completed={timesheet.New_IsCompleted}
              {staff}
              activityid={timesheet.ActivityId}
              actualstart={timesheet.ActualStart}
              status={data.Result.Status}
              {user} />
          {/each}
        </div>
      {:else}
        <div class="empty-timesheet-message">No data available</div>
      {/if}
    </div>
    <div class="day-container">
      <Header
        day={'Thursday'}
        date={thursday_date}
        hours={thursday_totalhours}
        ptoHours={thursday_total_pto_hours}
        otHours={thursday_total_ot_hours} />
      {#if thursday.length !== 0}
        <div class="cards-container">
          {#each thursday as timesheet}
            <TimesheetCards
              {newdate}
              {showDetails}
              collapseAll={collapse}
              title={timesheet.TaskNotes}
              timesheetId={timesheetId}
              job={timesheet.New_JobName}
              deliverable={timesheet.New_DeliverableName}
              task={timesheet.New_Costcentrename}
              taskid={timesheet.New_CostcentreId}
              totalhours={timesheet.New_Actualworkhrs}
              id={timesheet.New_DeliverableId}
              weekstart={modaldate}
              day={'Thursday'}
              jobid={timesheet.New_JobId}
              completed={timesheet.New_IsCompleted}
              {staff}
              activityid={timesheet.ActivityId}
              actualstart={timesheet.ActualStart}
              status={data.Result.Status}
              {user} />
          {/each}
        </div>
      {:else}
        <div class="empty-timesheet-message">No data available</div>
      {/if}
    </div>
    <div class="day-container">
      <Header
        day={'Friday'}
        date={friday_date}
        hours={friday_totalhours}
        ptoHours={friday_total_pto_hours}
        otHours={friday_total_ot_hours} />
      {#if friday.length !== 0}
        <div class="cards-container">
          {#each friday as timesheet}
            <TimesheetCards
              {newdate}
              {showDetails}
              collapseAll={collapse}
              title={timesheet.TaskNotes}
              timesheetId={timesheetId}
              job={timesheet.New_JobName}
              deliverable={timesheet.New_DeliverableName}
              task={timesheet.New_Costcentrename}
              taskid={timesheet.New_CostcentreId}
              totalhours={timesheet.New_Actualworkhrs}
              id={timesheet.New_DeliverableId}
              day={'Friday'}
              weekstart={modaldate}
              jobid={timesheet.New_JobId}
              completed={timesheet.New_IsCompleted}
              {staff}
              activityid={timesheet.ActivityId}
              actualstart={timesheet.ActualStart}
              status={data.Result.Status}
              {user} />
          {/each}
        </div>
      {:else}
        <div class="empty-timesheet-message">No data available</div>
      {/if}
    </div>
    <div class="day-container">
      <Header
        day={'Saturday'}
        date={saturday_date}
        hours={saturday_totalhours}
        ptoHours={saturday_total_pto_hours}
        otHours={saturday_total_ot_hours} />
      {#if saturday.length !== 0}
        <div class="cards-container">
          {#each saturday as timesheet}
            <TimesheetCards
              {newdate}
              {showDetails}
              collapseAll={collapse}
              title={timesheet.TaskNotes}
              timesheetId={timesheetId}
              job={timesheet.New_JobName}
              deliverable={timesheet.New_DeliverableName}
              task={timesheet.New_Costcentrename}
              taskid={timesheet.New_CostcentreId}
              totalhours={timesheet.New_Actualworkhrs}
              id={timesheet.New_DeliverableId}
              day={'Saturday'}
              weekstart={modaldate}
              jobid={timesheet.New_JobId}
              completed={timesheet.New_IsCompleted}
              {staff}
              activityid={timesheet.ActivityId}
              actualstart={timesheet.ActualStart}
              status={data.Result.Status}
              {user} />
          {/each}
        </div>
      {:else}
        <div class="empty-timesheet-message">No data available</div>
      {/if}
    </div>
    <div class="day-container">
      <Header
        day={'Sunday'}
        date={sunday_date}
        hours={sunday_totalhours}
        ptoHours={sunday_total_pto_hours}
        otHours={sunday_total_ot_hours} />
      {#if sunday.length !== 0}
        <div class="cards-container">
          {#each sunday as timesheet}
            <TimesheetCards
              {newdate}
              {showDetails}
              collapseAll={collapse}
              title={timesheet.TaskNotes}
              timesheetId={timesheetId}
              job={timesheet.New_JobName}
              deliverable={timesheet.New_DeliverableName}
              task={timesheet.New_Costcentrename}
              taskid={timesheet.New_CostcentreId}
              totalhours={timesheet.New_Actualworkhrs}
              id={timesheet.New_DeliverableId}
              day={'Sunday'}
              weekstart={modaldate}
              jobid={timesheet.New_JobId}
              completed={timesheet.New_IsCompleted}
              {staff}
              activityid={timesheet.ActivityId}
              actualstart={timesheet.ActualStart}
              status={data.Result.Status}
              {user} />
          {/each}
        </div>
      {:else}
        <div class="empty-timesheet-message">No data available</div>
      {/if}
    </div>
  </div>
{/if}
